import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";

export default function ProtectedRoute({ children }) {
  const { authed } = useAuth();
  const location = useLocation();

  if (!authed) return <Navigate to="/login" replace state={{ from: location }} />;
  return children;
}
